import { render, staticRenderFns } from "./serviceCenter.vue?vue&type=template&id=d5cb34ce&scoped=true&"
import script from "./serviceCenter.vue?vue&type=script&lang=js&"
export * from "./serviceCenter.vue?vue&type=script&lang=js&"
import style0 from "./serviceCenter.vue?vue&type=style&index=0&id=d5cb34ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cb34ce",
  null
  
)

export default component.exports